import { render, staticRenderFns } from "./SelectBoxTabFocus.vue?vue&type=template&id=4d510c08&scoped=true"
import script from "./SelectBoxTabFocus.vue?vue&type=script&lang=js"
export * from "./SelectBoxTabFocus.vue?vue&type=script&lang=js"
import style0 from "./SelectBoxTabFocus.vue?vue&type=style&index=0&id=4d510c08&prod&lang=scss&scoped=true"
import style1 from "./SelectBoxTabFocus.vue?vue&type=style&index=1&id=4d510c08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d510c08",
  null
  
)

export default component.exports